/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Status_IgnoredInputs */

const vi_reconcile_status_ignored = /** @type {(inputs: Reconcile_Status_IgnoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã bỏ qua`)
};

/**

* @param {Reconcile_Status_IgnoredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_status_ignored = /** @type {((inputs?: Reconcile_Status_IgnoredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Status_IgnoredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_status_ignored(inputs)
});